import React from 'react';
import { Row, Col } from 'react-bootstrap';
import styles from './inverter.module.css';

function Inverter({ inverter }) {
  return (
    <div className="mx-3">
      <strong>Inverter</strong>
      <div className={styles.logo}>
        <img src={inverter?.manufacturer.logo} alt="logo" width="90%" />
      </div>
      <div className={styles.info}>
        <Row className="mt-3">
          <Col>
            <strong>Model: </strong>
            {inverter?.model}
          </Col>
        </Row>
        <Row className="">
          <Col>
            <strong>Capacity: </strong>
            {`${inverter?.capacity} W`}
          </Col>
        </Row>
        <Row className="">
          <Col>
            <strong>Type: </strong>
            {inverter?.type == 'C' ? `Central` : `Micro`}
          </Col>
        </Row>
        <Row className="">
          <Col>
            <strong>Efficiency: </strong>
            {`${inverter?.efficiency}%`}
          </Col>
        </Row>
        {/* <Row className="">
          <Col>
            <strong>Degradation: </strong>
            {`${inverter.degradation}%`}
          </Col>
        </Row> */}
      </div>
    </div>
  );
}

export default Inverter;
